module.exports = __webpack_public_path__ + "account/assets/user.e5f3fd17.svg";